import { getEventTransfer } from "@convertkit/slate-react"
import parse from "../parser/parse"

export default () => ({
  onPaste: (event, editor, next) => {
    const { type, html, rich } = getEventTransfer(event)

    const currentLine = editor.value.startBlock.text
    if (type !== "html") return next()

    if (currentLine.includes("{%")) return next()
    if (currentLine.includes("{{")) return next()

    if (rich) return next()

    // We do not retain the font size from pasted content. In most
    // cases, users want to match the target font size.
    const { document } = parse(html, { fontSize: false })

    editor.insertFragment(document)
  }
})
